<template>
  <div class="pa-4 text-center conv" cols="12">
    <custom-popup v-model="showSingleImportModal"
                  :cons="{title:'بارگیری تکی آگهی'}"
                  hide-overlay
                  hide-confirm
                  max-width="500"
                  transition="dialog-bottom-transition">
      <v-card class="p-5">
        <v-text-field dense
                      placeholder="لینک مدیریت آگهی"
                      outline
                      v-model="advertiseUrl"
        />

        <div class="row col justify-content-end mx-auto">

          <v-btn @click="singleImport" color="green" class="mr-auto" :loading="loading">
            <v-icon class="ml-2">mdi-import</v-icon>
            افزودن
          </v-btn>
        </div>
      </v-card>
    </custom-popup>

    <v-dialog v-model="chargeDialog" width="650">
      <v-card>
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title> خرید شارژ</v-toolbar-title>
          <v-spacer/>
          <v-toolbar-items>
            <v-btn dark icon @click="chargeDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <charge-numbers v-if="chargeDialog" :selected_Num="selectedNumber"/>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addOwnNum" width="600">
      <v-card>
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title> افزودن شماره خود</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark icon @click="addOwnNum = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <add-new v-if="addOwnNum" :list="true"></add-new>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="infoDialog" width="400">
      <v-card>
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title> تعداد آگهی های شما در هر دسته</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark icon @click="infoDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text v-for="(item, i) in info" :key="i" class="mt-4">
          <p class="font-weight-bold text-dark">
            نام دسته :<span class="text-primary">{{
              translator(item.category)
            }}</span>
          </p>
          <p class="font-weight-bold text-dark my-0 py-0">
            تعداد آگهی :<span class="text-info">{{ item.count }}</span>
          </p>
        </v-card-text>
        <v-card-text v-if="info.length === 0" class="mt-5 mb-0">
          <p class="text-center font-weight-bold text-danger">
            متاسفانه شماره انتخابی شما آگهی در دیوار ندارد!
          </p>
        </v-card-text>

        <v-card-actions>
          <v-btn color="error" text @click="infoDialog = false"> بستن</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="packs" width="900">
      <v-card>
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title> لیست بسته های من</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark icon @click="packs = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <my-pakcs></my-pakcs>
        </v-card-text>
      </v-card>
    </v-dialog>

    <custom-popup
        v-model="showCharge"
        :cons="{ title: 'بررسی نردبان های من' }"
        hide-confirm
        hide-overlay
        max-width="500"
        transition="dialog-bottom-transition"
    >
      <v-card class="p-5">
        <charge-checker v-if="showCharge" :data="chargeID"/>
      </v-card>
    </custom-popup>

    <custom-popup
        v-model="TokenUpdate"
        :cons="{ title: 'به روزرسانی توکن' }"
        hide-confirm
        hide-overlay
        max-width="500"
        transition="dialog-bottom-transition"
    >
      <v-card class="p-5">
        <div class="col-md-8 col-12 text-center mx-auto">
          <v-otp-input
              ref="codes"
              v-model="logCode"
              length="6"
              style="direction: ltr"
              type="number"
              @finish="UpdateToken"
          />
        </div>
      </v-card>
    </custom-popup>

    <v-card-title class="justify-end">
      <v-btn class="ma-0 btn-add-with-text" depressed @click="addOwnNum = true">
        <span class="fa fa-plus ml-1"></span>
        افزودن شماره خود
      </v-btn>
    </v-card-title>

    <vue-table
        :data="data"
        :headers="headers"
        :props.sync="tableProps"
        @change="onPagination"
    >
      <template v-slot:filters="{ props, perPage }">
        <v-row no-gutters>
          <v-col class="pa-2" cols="12" lg="1" md="2">
            <v-select
                v-model="props.length"
                :items="perPage"
                class="rounded-lg"
                dense
                hide-details
                label="تعداد"
                outlined
            />
          </v-col>
          <v-col class="pa-2" cols="12" lg="4" md="6">
            <v-text-field
                v-model="props.search"
                append-icon="mdi-magnify"
                class="rounded-lg"
                clearable
                dense
                hide-details
                label="جستجو"
                outlined
            />
          </v-col>
        </v-row>
      </template>

      <template v-slot:index="{ item }">
        {{ item.index + 1 + (data.current_page - 1) * data.per_page }}
      </template>

      <template v-slot:phone="{ item }">
        {{ item.phone }}
        <br/>
        <p
            class="badge badge-info font-weight-bold p-1 ma-0 px-3 position-relative"
        >
          {{ item.phone | providers }}
          <span v-if="item.is_pro" class="number_pro success">Pro</span>
        </p>
      </template>

      <template v-slot:nickname="{ item }">
        <div class="w-100 d-flex align-center">
          {{ item.nickname }}
          <v-spacer/>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  color="grey darken-3"
                  icon
                  v-bind="attrs"
                  @click="
                  () => {
                    editNickname.item = item;
                    editNickname.dialog = true;
                  }
                "
                  v-on="on"
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>

            <span>ویرایش نام مستعار</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:token_time="{ item }">
        {{ datetime(item.token_time, "datetime") }}
      </template>

      <template v-slot:pro_date="{ item }">
        {{ datetime(item.pro_date, "datetime") }}
      </template>

      <template v-slot:can_divert="{ item }">
        <v-icon v-if="item.can_diver === 'yes'" color="green">mdi-check</v-icon>
        <v-icon v-else color="red">mdi-close</v-icon>
      </template>

      <template v-slot:user_number_pack="{ item }">
        <div
            v-if="item?.user_number_pack?.expire_at_diff?.includes('پیش')"
            :title="item.user_number_pack.expire_at_p"
            class="badge badge-danger"
        >
          {{ item?.user_number_pack?.expire_at_diff }}
        </div>

        <div
            v-else
            :title="item.user_number_pack.expire_at_p"
            class="badge badge-success"
        >
          {{ item?.user_number_pack?.expire_at_diff ?? "" }}
        </div>
      </template>

      <template v-slot:actions="{ item }">
        {{ item.actions }}
        <action-buttons :data="item" :meta="metaAction" class="my-3"/>
      </template>
    </vue-table>

    <custom-popup
        v-model="editNickname.dialog"
        :cons="nicknameCons"
        max-width="400"
    >
      <v-card class="pa-3" flat>
        <v-text-field
            v-model="editNickname.item.nickname"
            :loading="editNickname.loading"
            append-icon="mdi-account"
            clearable
            dense
            hide-details
            label="نام مستعار"
            outlined
            @keydown.enter="saveNickname"
        />
      </v-card>
    </custom-popup>
  </div>
</template>

<script>
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import actionButtons from "@/view/pages/button";
import ChargeNumbers from "@/view/pages/numbers/chargeNumbers";
import AddNew from "@/view/pages/numbers/addnew";
import myPakcs from "@/view/pages/numbers/myPakcs";
import CustomPopup from "@/core/plugins/TitleRibbon/plugins/popup/customPopup";
import ChargeChecker from "@/view/pages/numbers/chargeChecker";
import FiltersTable from "@/components/Table/filtersTable";

export default {
  name: "numbersList",

  components: {
    FiltersTable,
    ChargeChecker,
    CustomPopup,
    AddNew,
    ChargeNumbers,
    TitleRibbon,
    myPakcs,
    actionButtons,
  },

  filters: {
    providers(input) {
      switch (input) {
        case "divar":
          return "دیوار";
        case "divar_shop":
          return "فروشگاهی";
        case "divar_shop_pro":
          return "فروشگاهPro";
        case "divar_real_estate":
          return "املاک";
        case "divar_service":
          return "‌متخصص";
        case "car_business":
          return "نمایشگاه";
        default:
          return "شخصی";
      }
    },
  },

  data() {
    return {
      showSingleImportModal: false,
      selectedNumberId: undefined,
      advertiseUrl: undefined,
      infoDialog: false,
      chargeDialog: false,
      addOwnNum: false,
      loading: false,
      packs: false,
      numbersInfo: false,
      showCharge: false,
      TokenUpdate: false,
      info: [],
      editNickname: {
        dialog: false,
        item: {},
        loading: false,
      },
      nicknameCons: {
        title: "ویرایش نام مستعار",
        buttons: [{type: "submit", handler: () => this.saveNickname()}],
      },
      searchBox: {
        search: "",
        length: 10,
      },
      translates: [],
      chargeMount: [],
      selectedNumber: [],
      search: "",
      chargeID: "",
      dataId: "",
      logCode: "",
      loginPhone: "",
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
        page: 1,
      },
      data: {},
      headers: [
        {value: "index", text: "ردیف", sortable: false, align: "center"},
        {value: "phone", text: "شماره", sortable: false, align: "center"},
        {
          value: "nickname",
          text: "نام مستعار",
          sortable: false,
          align: "center",
        },
        {
          value: "token_time",
          text: "انقضا لاین",
          sortable: false,
          align: "center",
        },
        {
          value: "pro_date",
          text: "انقضا پرو",
          sortable: false,
          align: "center",
        },
        {value: "balance", text: "موجودی", sortable: false, align: "center"},
        {
          value: "total_post",
          text: "آگهی های ارسال شده",
          sortable: false,
          align: "center",
        },
        {
          value: "can_divert",
          text: "قابلیت دایورت",
          sortable: false,
          align: "center",
        },
        {
          value: "user_number_pack",
          text: "انقضا",
          sortable: false,
          align: "center",
        },
        {value: "actions", text: "مدیریت", sortable: false, align: "center"},
      ],
      metaAction: {
        permission_prefix: "notification_",
        buttons: [
          {
            name: "divarAds",
            label: "بارگیری آگهی ها",
            icon: "download",
            class: "btn-outline-info",
            status: "divar_import",
            action: this.actions,
            condition: (status, val) => {
              return !val?.user_number_pack?.expire_at_diff?.includes("پیش");
            },
          },
          {
            name: "divarAdsSingleImport",
            label: "بارگیری آگهی (تکی)",
            icon: "link",
            class: "btn-outline-danger",
            status: "divar_import",
            action: this.actions,
            condition: (status, val) => {
              return !val?.user_number_pack?.expire_at_diff?.includes("پیش");
            },
          },
          {
            name: "refresh",
            label: "تمدید",
            icon: "retweet",
            class: "btn-outline-primary",
            action: this.actions,
            status: "number_list",
            condition: (status, val) => {
              return status;
            },
          },
          {
            name: "categoryAds",
            label: "تعدادآگهی",
            icon: "info-circle",
            class: "btn-outline-success",
            action: this.actions,
            status: "number_list",
            condition: (status, val) => {
              if (val?.user_number_pack?.expire_at_diff?.includes("پیش"))
                return false;
              else return true;
            },
          },
          {
            name: "updatePanel",
            label: "آپدیت وضعیت پنل",
            icon: "upload",
            class: "btn-outline-warning",
            action: this.actions,
            status: "number_list",
            condition: this.buttonsCondition,
          },
          {
            name: "getPro",
            label: "شماره پرو",
            icon: "medal",
            class: "btn-outline-success",
            action: this.actions,
            status: "number_list",
            condition: (status, val) => {
              return this.buttonsCondition(status, val) && val.marketplace
                  ? true
                  : false;
            },
          },
          {
            name: "credit",
            label: "بررسی شارژ پروفایل",
            icon: "coins",
            class: "btn-outline-info",
            action: this.actions,
            status: "number_list",
            condition: (status, data, vm) => {
              return data?.marketplace?.provider === "divar_service" &&
              vm?.user?.ablities.indexOf("gradual_service:active") > -1 &&
              !data?.user_number_pack?.expire_at_diff.includes("پیش")
                  ? true
                  : false;
            },
          },
          {
            name: "doLadder",
            label: "نردبان پروفایل",
            icon: "thumbs-up",
            class: "btn-outline-info",
            action: this.actions,
            status: "number_list",
            condition: (status, data, vm) => {
              if (data.user_number_pack.expire_at_diff.includes("پیش"))
                return false;

              return data?.marketplace?.provider === "divar_service" &&
              vm?.user?.ablities.indexOf("gradual_service:active") > -1
                  ? true
                  : false;
            },
          },
          {
            name: "updateToken",
            label: "آپدیت شماره",
            icon: "refresh",
            class: "btn-outline-danger",
            action: this.actions,
            status: "number_list",
            condition: (status, val) => {
              if (val?.user_number_pack?.expire_at_diff?.includes("پیش"))
                return false;
              else return true;
            },
          },
        ],
      },
    };
  },

  mounted() {
    this.tableProps = {
      search: "",
      length: 10,
      column: "id",
      dir: "desc",
      page: 1,
    };

    this.getDataForTable();
    this.getLocalization();
  },

  watch: {
    selectedNumber(val) {
      if (val.length <= 0) {
        this.chargeDialog = false;
      }
    },
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true,
    },
  },

  methods: {
    buttonsCondition(status, val) {
      return (
          ["null"].indexOf(status) <= -1 &&
          !val?.user_number_pack?.expire_at_diff?.includes("پیش")
      );
    },
    getDataForTable(params = this.tableProps) {
      const vm = this;
      vm.loading = true;

      let url = `${window.url}/number`;

      $.ajax({
        url: url,
        type: "GET",
        fn: this.getDataForTable,
        data: params,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        success: function (data) {
          vm.data = data;
          vm.loading = false;
        },
      });
    },
    onPagination(e) {
      this.loading = true;
      let props = {
        ...this.tableProps,
        ...e,
      };

      this.getDataForTable(props);
    },
    UpdateToken() {
      $.ajax({
        url: `${url}/admin/numbers/set/token/${this.loginPhone}`,
        type: "PUT",
        fn: this.UpdateToken,
        headers: {
          ACCEPT: "application/json",
          AUTHORIZATION: Token,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({code: this.logCode}),
        msg: true,
        success: (res) => {
          this.TokenUpdate = false;
          this.logCode = "";
        },
      });
    },
    actions(data, type) {
      switch (type) {
        case "divarAds":
          $.ajax({
            url: `${url}/divar/import/${data.id}`,
            type: "POST",
            fn: this.actions,
            params: [data, type],
            headers: {
              ACCEPT: "application/json",
              Authorization: Token,
            },
            msg: true,
          });
          break;
        case 'divarAdsSingleImport':
          this.selectedNumberId = data.id;
          this.showSingleImportModal = true;
          break;
        case "refresh":
          this.onRefresh(data, type);
          break;
        case "categoryAds":
          this.infoDialog = true;
          this.info = data.number_categories;
          break;
        case "updatePanel":
          $.ajax({
            url: `${url}/phone/marketplace/${data.id}`,
            type: "PUT",
            fn: this.actions,
            params: [data],
            headers: {
              ACCEPT: "application/json",
              Authorization: Token,
            },
            msg: true,
          });
          break;
        case "credit":
          this.showCharge = true;
          this.chargeID = data.id;
          break;
        case "doLadder":
          this.$modal
              .yesNo("نردبان", "آیا از نردبان کردن پروفایل خود مطمئن هستید؟")
              .then((value) => {
                if (!value) return;

                $.ajax({
                  url: `${url}/divar/service/ladder/${data.id}`,
                  type: "POST",
                  fn: this.actions,
                  params: [data],
                  headers: {
                    ACCEPT: "application/json",
                    Authorization: Token,
                  },
                  success: (data) => {
                    this.$nextTick(() => {
                      this.$modal.success("موفقیت", data.message);
                    });
                  },
                });
              });

          break;
        case "expertWallet":
          this.$modal
              .yesNo("پرداخت از کیف پول", "آیا از انجام این کار مطمئن هستید؟")
              .then((value) => {
                if (!value) return;

                $.ajax({
                  url: `${url}/divar/service/ladder/order/wallet/${data.id}`,
                  type: "POST",
                  fn: this.actions,
                  headers: {
                    ACCEPT: "application/json",
                    Authorization: Token,
                  },
                  success: (data) => {
                    this.$nextTick(() => {
                      this.$modal.success("موفقیت", data.message);
                    });
                  },
                });
              });

          break;
        case "updateToken":
          this.TokenUpdate = true;
          this.loginPhone = data.phone;

          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs.codes.focus();
            });
          });

          $.ajax({
            url: `${url}/phone/authenticate`,
            type: "POST",
            data: JSON.stringify({phone: data.phone}),
            headers: {
              ACCEPT: "application/json",
              Authorization: Token,
              "Content-Type": "application/json",
            },
            msg: true,
          });

          break;
        case "getPro":
          this.onGetPro(data);
          break;
      }
    },
    check(e) {
      const id = e.target.dataset.id;
      const checked = e.target.checked;
      const index = this.data.data.findIndex((item) => item.id === id);
      this.data.data[index].checked = checked;
    },
    addAmount(amount) {
      if (amount) {
        this.chargeMount = Number(amount) + Number(this.chargeMount);
        this.groupModal = true;
      }
    },
    deleteNumber(item) {
      this.selectedNumber.splice(this.selectedNumber.indexOf(item), 1);
    },
    getLocalization() {
      if (localStorage.getItem("localization")) {
        this.translates = JSON.parse(localStorage.getItem("localization"));
        return;
      }
      $.ajax({
        url: `${url}/setting/localization`,
        type: "GET",
        fn: this.getLocalization,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        success: (data) => {
          this.translates = data;
          localStorage.setItem("localization", JSON.stringify(data));
        },
      });
    },
    translator(name) {
      return this.translates[name];
    },
    async onRefresh(data, type) {
      if (
          await this.$modal.yesNo("تایید پرداخت تمدید؟", "100.000 ﷼ + 10٪ مالیات")
      ) {
        const uniq = data.user_number_pack.uniq;
        if (uniq !== undefined) {
          $.ajax({
            url: `${url}/shop/numbers/${uniq}/renew`,
            type: "POST",
            fn: this.actions,
            params: [data, type],
            headers: {
              ACCEPT: "application/json",
              Authorization: Token,
            },
            data: {
              uniq: uniq,
            },
            msg: true,
            statusCode: {
              200: (data) => {
                this.onPagination();
              },
            },
          });
        } else
          $.ajax({
            url: `${url}/shop/number/slot/${data.id}`,
            type: "PUT",
            fn: this.actions,
            params: [data, type],
            headers: {
              ACCEPT: "application/json",
              Authorization: Token,
            },
            msg: true,
          });
      }
    },
    async onGetPro(data) {
      if (
          await this.$modal.yesNo("تایید پرداخت پرو؟", "9.800.000 ﷼ + 10٪ مالیات")
      ) {
        $.ajax({
          url: `${url}/phone/pro/${data.id}`,
          type: "PUT",
          fn: this.actions,
          headers: {
            ACCEPT: "application/json",
            Authorization: Token,
          },
          success: (data) => {
            this.getDataForTable();
            this.$nextTick(() => {
              this.$modal.success("موفقیت", data.message);
            });
          },
        });
      }
    },
    saveNickname() {
      let item = this.editNickname.item;

      if (!item.nickname)
        return this.$toast.error("لطفا نام مستعار را صحیح وارد نمایید!");

      this.editNickname.loading = true;
      const _this = this;
      let url = `${window.url}/number/${item.id}`;

      $.ajax({
        url: url,
        type: "PUT",
        fn: this.saveNickname,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        data: {
          nickname: item.nickname,
        },
        success: function (data) {
          _this.$toast.success("نام مستعار با موفقیت ویرایش شد.");
          _this.getDataForTable({..._this.tableProps, page: 1});
          _this.editNickname.dialog = false;
          _this.editNickname.loading = false;
        },
        error: function (jqXHR, textStatus, errorThrown) {
          _this.$toast.error("خطا در ویرایش نام مستعار.");
          _this.editNickname.loading = false;
          console.error("Error:", textStatus, errorThrown);
        },
      });
    },
    singleImport() {
      this.loading=true;
      $.ajax({
        url: `${url}/divar/import/${this.selectedNumberId}/single`,
        type: "POST",
        data: {advertise: this.advertiseUrl},
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        msg: true,
        success:()=>{
          this.advertiseUrl=undefined
        }
      }).always(()=>{
        this.loading=false;
      });

    }
  },
};
</script>

<style>
.number_pro {
  color: white;
  font-size: 10px;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 20px;
  transform: translateX(-50%) translateY(75%);
  position: absolute;
  bottom: 0;
  left: 50%;
}

.conv {
  overflow-y: auto !important;
  height: max-content;
  max-height: 100%;
  min-height: 100vh !important;
}
</style>
